var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
const defaultReducerState = {
  workspaceId: "",
  name: "",
  sparkComputeType: "",
  owners: [],
  createCompute: getDefaultAsyncWrapperObj(),
  updateCompute: getDefaultAsyncWrapperObj(),
  synapseSubClusterList: [],
  cluster: "",
  vcName: "",
  maxConcurrency: "",
  servicePrincipalName: "",
  adlaAccountName: "",
  servicePrincipalNameList: getDefaultAsyncWrapperObj(),
  managedIdentityList: getDefaultAsyncWrapperObj(),
  managedIdentityId: "",
  touchTabs: {
    basic: false,
    subCluster: false
  }
};
const loadServicePrincipalNameListPrefix = "loadServicePrincipalNameList";
const loadServicePrincipalNameListActionTypes = {
  LOAD: `${loadServicePrincipalNameListPrefix}/LOAD`,
  LOADING: `${loadServicePrincipalNameListPrefix}/LOADING`,
  LOADED: `${loadServicePrincipalNameListPrefix}/LOADED`
};
const loadManagedIdentityListPrefix = "loadManagedIdentityList";
const loadManagedIdentityListActionTypes = {
  LOAD: `${loadManagedIdentityListPrefix}/LOAD`,
  LOADING: `${loadManagedIdentityListPrefix}/LOADING`,
  LOADED: `${loadManagedIdentityListPrefix}/LOADED`
};
const createComputePrefix = "createCompute";
const createComputeActionTypes = {
  LOAD: `${createComputePrefix}/LOAD`,
  LOADING: `${createComputePrefix}/LOADING`,
  LOADED: `${createComputePrefix}/LOADED`
};
const updateComputePrefix = "updateCompute";
const updateComputeActionTypes = {
  LOAD: `${updateComputePrefix}/LOAD`,
  LOADING: `${updateComputePrefix}/LOADING`,
  LOADED: `${updateComputePrefix}/LOADED`
};
const CLEAR_COMPUTE_UPDATE_ACTION = `${updateComputePrefix}/CLEAR_REQUEST`;
const createComputeConstants = {
  setNameContext: `${createComputePrefix}/SetNameContext`,
  setSparkComputeTypeContext: `${createComputePrefix}/SetSparkComputeTypeContext`,
  setOwnersContext: `${createComputePrefix}/SetOwnersContext`,
  setSynapseContext: `${createComputePrefix}/SetSynapseContext`,
  setClusterContext: `${createComputePrefix}/SetClusterContext`,
  setVCNameContext: `${createComputePrefix}/SetVCNameContext`,
  setMaxConcurrencyContext: `${createComputePrefix}/SetMaxConcurrencyContext`,
  setServicePrincipalNameContext: `${createComputePrefix}/setServicePrincipalNameContext`,
  setManagedIdentityIdContext: `${createComputePrefix}/setManagedIdentityIdContext`,
  setAdlaAccountNameContext: `${createComputePrefix}/setAdlaAccountNameContext`,
  setTouchTabs: `${createComputePrefix}/SetTouchTabs`,
  setCreateCompute: `${createComputePrefix}/SetCreateCompute`,
  setUpdateCompute: `${createComputePrefix}/setUpdateCompute`
};
function SetNameContext(name) {
  return {
    type: createComputeConstants.setNameContext,
    payload: name
  };
}
function SetSparkComputeTypeContext(sparkComputeType) {
  return {
    type: createComputeConstants.setSparkComputeTypeContext,
    payload: sparkComputeType
  };
}
function SetOwnersContext(owners) {
  return {
    type: createComputeConstants.setOwnersContext,
    payload: owners
  };
}
function SetSynapseSubClusterListContext(synapseSubClusterList) {
  return {
    type: createComputeConstants.setSynapseContext,
    payload: synapseSubClusterList
  };
}
function SetClusterContext(cluster) {
  return {
    type: createComputeConstants.setClusterContext,
    payload: cluster
  };
}
function SetVCNameContext(vcName) {
  return {
    type: createComputeConstants.setVCNameContext,
    payload: vcName
  };
}
function SetMaxConcurrencyContext(maxConcurrency) {
  return {
    type: createComputeConstants.setMaxConcurrencyContext,
    payload: maxConcurrency
  };
}
function SetServicePrincipalNameContext(servicePrincipalName) {
  return {
    type: createComputeConstants.setServicePrincipalNameContext,
    payload: servicePrincipalName
  };
}
function SetManagedIdentityIdContext(managedIdentityId) {
  return {
    type: createComputeConstants.setManagedIdentityIdContext,
    payload: managedIdentityId
  };
}
function SetAdlaAccountNameContext(adlaAccountName) {
  return {
    type: createComputeConstants.setAdlaAccountNameContext,
    payload: adlaAccountName
  };
}
function SetTouchTabs(touchTabs) {
  return {
    type: createComputeConstants.setTouchTabs,
    payload: touchTabs
  };
}
function SetCreateCompute(createCompute2) {
  return {
    type: createComputeConstants.setCreateCompute,
    payload: createCompute2
  };
}
function SetUpdateCompute(updateCompute2) {
  return {
    type: createComputeConstants.setUpdateCompute,
    payload: updateCompute2
  };
}
const setNameContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    name: actionResult.payload.name
  });
};
const setSparkComputeTypeContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    sparkComputeType: actionResult.payload.sparkComputeType
  });
};
const setOwnersContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    owners: actionResult.payload.owners
  });
};
const setSynapseSubClusterListContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    synapseSubClusterList: actionResult.payload.synapseSubClusterList
  });
};
const setClusterContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    cluster: actionResult.payload.cluster
  });
};
const setVCNameContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    vcName: actionResult.payload.vcName
  });
};
const setMaxConcurrencyContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    maxConcurrency: actionResult.payload.maxConcurrency
  });
};
const setServicePrincipalNameContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    servicePrincipalName: actionResult.payload.servicePrincipalName
  });
};
const setManagedIdentityIdContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    managedIdentityId: actionResult.payload.managedIdentityId
  });
};
const setAdlaAccountNameContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    adlaAccountName: actionResult.payload.adlaAccountName
  });
};
const setTouchTabs = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    touchTabs: actionResult.payload.touchTabs
  });
};
const setCreateCompute = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    createCompute: actionResult.payload.createCompute
  });
};
const setUpdateCompute = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    updateCompute: actionResult.payload.updateCompute
  });
};
const loadServicePrincipalNameList = (workspaceId) => {
  return {
    type: loadServicePrincipalNameListActionTypes.LOAD,
    payload: {
      workspaceId
    }
  };
};
const loadingServicePrincipalNameList = (workspaceId) => {
  return {
    type: loadServicePrincipalNameListActionTypes.LOADING,
    payload: {
      workspaceId
    }
  };
};
const loadedServicePrincipalNameList = (workspaceId, servicePrincipalNameList) => {
  return {
    type: loadServicePrincipalNameListActionTypes.LOADED,
    payload: {
      workspaceId,
      servicePrincipalNameList
    }
  };
};
const loadManagedIdentityList = (workspaceId) => {
  return {
    type: loadManagedIdentityListActionTypes.LOAD,
    payload: {
      workspaceId
    }
  };
};
const loadingManagedIdentityList = (workspaceId) => {
  return {
    type: loadManagedIdentityListActionTypes.LOADING,
    payload: {
      workspaceId
    }
  };
};
const loadedManagedIdentityList = (workspaceId, managedIdentityList) => {
  return {
    type: loadManagedIdentityListActionTypes.LOADED,
    payload: {
      workspaceId,
      managedIdentityList
    }
  };
};
const createCompute = (workspaceId, computeConfiguration) => {
  return {
    type: createComputeActionTypes.LOAD,
    payload: computeConfiguration
  };
};
const creatingCompute = () => {
  return {
    type: createComputeActionTypes.LOADING,
    payload: {}
  };
};
const createdCompute = (createCompute2) => {
  return {
    type: createComputeActionTypes.LOADED,
    payload: {
      createCompute: createCompute2
    }
  };
};
const updateCompute = (computeConfiguration) => {
  return {
    type: updateComputeActionTypes.LOAD,
    payload: computeConfiguration
  };
};
const updatingCompute = () => {
  return {
    type: updateComputeActionTypes.LOADING,
    payload: {}
  };
};
const updatedCompute = (updateCompute2) => {
  return {
    type: updateComputeActionTypes.LOADED,
    payload: {
      updateCompute: updateCompute2
    }
  };
};
const clearComputeUpdateRequest = () => {
  return {
    type: CLEAR_COMPUTE_UPDATE_ACTION
  };
};
const computeCreateReducer = (state = defaultReducerState, action) => {
  var _a, _b, _c, _d, _e, _f;
  switch (action.type) {
    case createComputeConstants.setNameContext:
      return setNameContext(state, action);
    case createComputeConstants.setSparkComputeTypeContext:
      return setSparkComputeTypeContext(state, action);
    case createComputeConstants.setOwnersContext:
      return setOwnersContext(state, action);
    case createComputeConstants.setSynapseContext:
      return setSynapseSubClusterListContext(state, action);
    case createComputeConstants.setClusterContext:
      return setClusterContext(state, action);
    case createComputeConstants.setVCNameContext:
      return setVCNameContext(state, action);
    case createComputeConstants.setMaxConcurrencyContext:
      return setMaxConcurrencyContext(state, action);
    case createComputeConstants.setServicePrincipalNameContext:
      return setServicePrincipalNameContext(state, action);
    case createComputeConstants.setManagedIdentityIdContext:
      return setManagedIdentityIdContext(state, action);
    case createComputeConstants.setAdlaAccountNameContext:
      return setAdlaAccountNameContext(state, action);
    case createComputeConstants.setTouchTabs:
      return setTouchTabs(state, action);
    case createComputeConstants.setCreateCompute:
      return setCreateCompute(state, action);
    case createComputeConstants.setUpdateCompute:
      return setUpdateCompute(state, action);
    case loadServicePrincipalNameListActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        servicePrincipalNameList: __spreadProps(__spreadValues({}, state.servicePrincipalNameList), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadManagedIdentityListActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        managedIdentityList: __spreadProps(__spreadValues({}, state.managedIdentityList), {
          status: AsyncRequestStatus.Pending
        })
      });
    case createComputeActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        createCompute: __spreadProps(__spreadValues({}, state.createCompute), {
          status: AsyncRequestStatus.Pending
        })
      });
    case updateComputeActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        updateCompute: __spreadProps(__spreadValues({}, state.updateCompute), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadServicePrincipalNameListActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        servicePrincipalNameList: __spreadProps(__spreadValues({}, state.servicePrincipalNameList), {
          data: (_a = action.payload.servicePrincipalNameList) == null ? void 0 : _a.data,
          status: !!((_b = action.payload.servicePrincipalNameList) == null ? void 0 : _b.error) ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          error: (_c = action.payload.servicePrincipalNameList) == null ? void 0 : _c.error
        })
      });
    case loadManagedIdentityListActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        managedIdentityList: __spreadProps(__spreadValues({}, state.managedIdentityList), {
          data: (_d = action.payload.managedIdentityList) == null ? void 0 : _d.data,
          status: !!((_e = action.payload.managedIdentityList) == null ? void 0 : _e.error) ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          error: (_f = action.payload.managedIdentityList) == null ? void 0 : _f.error
        })
      });
    case createComputeActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        createCompute: __spreadProps(__spreadValues({}, state.createCompute), {
          data: action.payload.createCompute.data,
          status: !!action.payload.createCompute.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          error: action.payload.createCompute.error
        })
      });
    case updateComputeActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        updateCompute: __spreadProps(__spreadValues({}, state.updateCompute), {
          data: action.payload.updateCompute.data,
          status: !!action.payload.updateCompute.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          error: action.payload.updateCompute.error
        })
      });
    case CLEAR_COMPUTE_UPDATE_ACTION:
      return __spreadProps(__spreadValues({}, state), {
        updateCompute: getDefaultAsyncWrapperObj()
      });
    default:
      return state;
  }
};
export {
  CLEAR_COMPUTE_UPDATE_ACTION,
  SetAdlaAccountNameContext,
  SetClusterContext,
  SetCreateCompute,
  SetManagedIdentityIdContext,
  SetMaxConcurrencyContext,
  SetNameContext,
  SetOwnersContext,
  SetServicePrincipalNameContext,
  SetSparkComputeTypeContext,
  SetSynapseSubClusterListContext,
  SetTouchTabs,
  SetUpdateCompute,
  SetVCNameContext,
  clearComputeUpdateRequest,
  computeCreateReducer,
  createCompute,
  createComputeActionTypes,
  createComputeConstants,
  createdCompute,
  creatingCompute,
  computeCreateReducer as default,
  defaultReducerState,
  loadManagedIdentityList,
  loadManagedIdentityListActionTypes,
  loadServicePrincipalNameList,
  loadServicePrincipalNameListActionTypes,
  loadedManagedIdentityList,
  loadedServicePrincipalNameList,
  loadingManagedIdentityList,
  loadingServicePrincipalNameList,
  updateCompute,
  updateComputeActionTypes,
  updatedCompute,
  updatingCompute
};
//# sourceMappingURL=ComputeCreateContainer.ducks.js.map
